export default __webpack_public_path__ + "static/media/LogoC1Entertainment.327bee49.svg";